class Controller {
  constructor($mdToast, ticket) {
    "ngInject";

    this.$mdToast = $mdToast;
    this.ticket = ticket;
    this.title = this.ticket.title;
  }

  close() {
    this.$mdToast.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/ticketNotification/toast/toast.controller.js